module.exports = __webpack_public_path__ + "img/img0202.bae80af0.png";